<template>
  <div class="fill-height">


    <v-card class="fill-height">
      <v-card-title  class="p-1">
        <v-chip
            label    small
            class="ma-2"
            color="secondary">
          تعریف گروه تخفیفات
        </v-chip>
        <v-spacer/>
        <v-btn light icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>

        <v-row>
          <v-col cols="12"
                 sm="2"
                 v-if="can('newMainGroup')" class="d-inline-block">
            <v-btn class="float-right "
                   color="primary"
                   right
                   fab
                   small
                   @click="forNew()"
            >
              <v-icon>fa fa-plus</v-icon>
            </v-btn>
            <create-mainGroup :model="model" :selected="selected" :dialogStatus.sync="showDialog"/>
          </v-col>
          <v-col cols="12"
                 sm="12"
                 md="4"
                 class="d-inline-flex"
          >
            <v-text-field
                outlined
                dense
                placeholder="نام گروه"
                v-model="searchvalue"
                @click="search"

            />
            <v-btn  fab small color="primary" @click="search" class="mr-1">
              <v-icon>mdi-cloud-search</v-icon>
            </v-btn>

          </v-col>
          <v-col cols="12"
                 sm="12"
                 md="6" class="d-inline-block">
            <b-pagination
                v-model="skip"
                :total-rows="paging.totalSize"
                :per-page=take
                first-text="اولین"
                prev-text="<"
                next-text=">"
                last-text="آخرین"
                dir="ltr"
                limit="5"
                @change="pageChangeHandler"
            />

          </v-col>


        </v-row>


        <v-spacer/>

        <v-spacer/>
        <b-table
            v-if="can('mainGroupList')"
            :items="dataItems"
            :fields="columns"
            :current-page="skip"
            :per-page=0
            stacked="md"
            show-empty
             striped
        >
          <template #cell(actions)="row">

            <v-btn depressed small v-if="can('editMainGroup')" color="primary" @click="forEdit(row.item)" class="mr-1 ">
              ویرایش
            </v-btn>
            <v-btn depressed class="mr-1" v-if="can('deleteMainGroup')" small color="error" @click="remove(row.item)">
              حذف
            </v-btn>
          </template>
        </b-table>


      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import CreateMainGroup from './PageEdit'
import MainGroup_se from "./MainGroup_se";
import {mapMutations} from "vuex";


export default {
  name: 'MainGroup',
  components: {
    CreateMainGroup
  },
  data() {
    return {
      searchvalue: '',
      modelId: '',
      model: {},
      selected:[],
      mainGroupId:'all',
      showDialog: false,
      modelAtributes: {},
      dataItems: [],
      paging: {},
      skip: 1,
      take: 10,
      currentPage: 1,
      columns: [
        {key: 'nameGroup', label: 'نام', sortable: true, sortDirection: 'desc'},

        {key: 'actions', label: 'عملیات'}
      ],

    };

  },

  mounted() {
    this.$root.$on('MainGroup', () => {

      this.fillDataItems()
    })

  },

  methods: {
    close(){
      this.searchvalue=""
      this.$root.$emit('MainGroup')
      this.$router.push('/home')
    },
    ...mapMutations({
      setDrawer: 'SET_DRAWER',
      setMini: 'SET_MINI',
    }),

    fetch() {
      MainGroup_se.getById(this.modelId).then(response => {
        this.model = response.data.model
      })
      this.showDialog = true;
    },
    forEdit: function (e) {
      this.modelId = e.id;
      this.fetch()
    },

    forNew: function () {
      this.model = {};
      this.modelId = '';
      this.fetch()
    },

    remove: function (e) {
      this.$confirm()
          .then(isDestroyed => isDestroyed &&
              MainGroup_se.delete(e.id).then(response => {
                if (response && response.status === 200) {
                  this.$snack({type: 'success'})
                  this.fillDataItems()
                } else {
                  this.$snack({type: 'error'})
                }
              })
          )
    },

    pageChangeHandler: function (event) {
      this.skip = event;
      this.fillDataItems();

    },

    fillDataItems() {
      this.modelAtributes = (MainGroup_se.getPage( this.skip - 1, this.take).then(response => {
        this.modelAtributes = response.data
        this.paging = this.modelAtributes.page
        this.dataItems = this.modelAtributes.mainGroupList

      }));
    },

    search(){
      if(this.searchvalue.length>2){
        MainGroup_se.search(this.searchvalue,this.skip-1, this.take).then(result=>{
          this.dataItems=result.data
        })
      }else if(this.searchvalue.length===0){
        this.fillDataItems()

      }
    }

  },

  created() {
    this.setDrawer(false)
    this.fillDataItems();
  }

}
</script>

<style>
.table th, .table td {
  padding: 5px !important;
}

</style>
